var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F2F4F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2574_284)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3332 15.8445C27.3332 16.5223 26.9645 17.1141 26.4165 17.4307V17.6756H32.8332C34.352 17.6756 35.5832 18.9054 35.5832 20.4223V31.4089C35.5832 32.9259 34.352 34.1555 32.8332 34.1555H18.1665C16.6477 34.1555 15.4165 32.9259 15.4165 31.4089V20.4223C15.4165 18.9054 16.6477 17.6756 18.1665 17.6756H24.5832V17.4307C24.0352 17.1141 23.6665 16.5223 23.6665 15.8445C23.6665 14.8332 24.4873 14.0134 25.4998 14.0134C26.5124 14.0134 27.3332 14.8332 27.3332 15.8445ZM18.1665 19.5067H24.5832H26.4165H32.8332C33.3395 19.5067 33.7498 19.9166 33.7498 20.4223V31.4089C33.7498 31.9146 33.3395 32.3244 32.8332 32.3244H18.1665C17.6602 32.3244 17.2498 31.9146 17.2498 31.4089V20.4223C17.2498 19.9166 17.6602 19.5067 18.1665 19.5067ZM28.2498 24.5423C28.2498 23.7838 28.8655 23.1689 29.6248 23.1689C30.3842 23.1689 30.9998 23.7838 30.9998 24.5423C30.9998 25.3007 30.3842 25.9156 29.6248 25.9156C28.8655 25.9156 28.2498 25.3007 28.2498 24.5423ZM29.6248 21.3378C27.8529 21.3378 26.4165 22.7725 26.4165 24.5423C26.4165 26.312 27.8529 27.7467 29.6248 27.7467C31.3968 27.7467 32.8332 26.312 32.8332 24.5423C32.8332 22.7725 31.3968 21.3378 29.6248 21.3378ZM21.3748 23.1689C20.6154 23.1689 19.9998 23.7838 19.9998 24.5423C19.9998 25.3007 20.6154 25.9156 21.3748 25.9156C22.1342 25.9156 22.7498 25.3007 22.7498 24.5423C22.7498 23.7838 22.1342 23.1689 21.3748 23.1689ZM18.1665 24.5423C18.1665 22.7725 19.6029 21.3378 21.3748 21.3378C23.1468 21.3378 24.5832 22.7725 24.5832 24.5423C24.5832 26.312 23.1468 27.7467 21.3748 27.7467C19.6029 27.7467 18.1665 26.312 18.1665 24.5423ZM24.4864 29.1684C24.26 28.7161 23.7094 28.5328 23.2566 28.7589C22.8037 28.9851 22.6202 29.5349 22.8466 29.9872C23.3737 31.04 24.5669 31.4089 25.4998 31.4089C26.4328 31.4089 27.626 31.04 28.153 29.9872C28.3795 29.5349 28.1959 28.9851 27.7431 28.7589C27.2903 28.5328 26.7397 28.7161 26.5133 29.1684C26.4293 29.3363 26.0946 29.5778 25.4998 29.5778C24.9051 29.5778 24.5704 29.3363 24.4864 29.1684Z",
    fill: "#1D4ED8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2574_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.9732,
    fill: "white",
    transform: "translate(14.5 14.0134)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.63c11e0c0d16ee5680ed5e54ba9f357a.svg";
export { ForwardRef as ReactComponent };